// extracted by mini-css-extract-plugin
module.exports = {"root":"style_root__2t8DK","item":"style_item__8R6W0"};